import { sortBy } from 'underscore';
import { frontend_flags } from '../../index';

export function sortProcess (process = {}, max = 5) {
  const values = sortBy(Object.values(process), 'start_time').reverse();
  if (values.length > max) values.length = max;
  return values.reduce((acc, data) => ({ ...acc, [data.process_id]: data }), {});
}

export function getPersistedData (key, state) {
  if (key === 'jobs') {
    return {
      ...state,
      selected_jobs: [],
      start: undefined,
      destination: undefined,
      focused_route: {
        route: null,
        color: null
      },
      deliveries: {
        deliveries: [],
        tuples: [],
        deliveriesById: {}
      },
      all_jobs_selected: false,
      focus_list_item: null,
      activeView: 0
    };
  }
  return {
    ...state,
    loadunits: {
      num_results: 0,
      total_pages: undefined,
      page: 0,
      draft: undefined,
      selected_dimension: 0,
      units: []
    },
    use_territories: false,
    loading: false,
    ui: (typeof frontend_flags !== 'undefined' ? frontend_flags : []),
    correction: {
      action: null,
      open: false
    }
  };
}

export function setPersistedData (state) {
 
  return {
    ...state,
    process: sortProcess(state.process, 5),
    loadunits: {
      num_results: 0,
      total_pages: undefined,
      page: 0,
      draft: undefined,
      selected_dimension: 0,
      units: []
    },
    chunks: {
      chunkIndex: 0,
      chunks: [],
      activeChunk: []
    },
    deliveries: {
      deliveries: [],
      tuples: [],
      deliveriesById: {}
    }
  };
}
